import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Component/css/common.css';
import AddBoxiconsCSS from './AddBoxiconsCSS';
import ScrollToTop from './ScrollToTop';
// Import the Home component from src/Pages/Home.js
import Home from './Pages/Home';
import Event from './Pages/Event';
import VisitorLogin from './Pages/VisitorLogin';
import AllEvent from './Pages/AllEvent';
import TopEvent from './Pages/TopEvent';
import Profile from './Pages/Profile';
import ChangePassword from './Pages/ChangePassword'; 
import MyEvent from './Pages/MyEvent';
import EventCalander from './Pages/EventCalander';
import VisitorRegistration from './Pages/VisitorRegistration';
import Message from './Pages/Message';
import Connection from './Pages/Connection';
import Follow from './Pages/Follow';
import ConnectionPending from './Pages/ConnectionPending';
import Contact from './Pages/Contact';
import Login from './Pages/Login';
import OTP from './Pages/OTP';
import Exhibition from './Pages/Exhibition';
import Conference from './Pages/Conference';
import ProfileMain from './Pages/ProfileMain';
import AllConference from './Pages/AllConference';
import Search from './Pages/Search'; 
import Blog from './Pages/Blog';
import FillCustomForm from './Pages/FillCustomForm';
import Privacy from './Pages/Privacy';
import Terms from './Pages/Terms';
import ExhibitionNew from './Pages/ExhibitionNew';
import AllReviews from './Pages/AllReviews';
import AllReviewsConference from './Pages/AllreviewsConference';


import AllSpeakers from './Component/AllSpeakers'; 
import AllPartners from './Component/AllPartners';
import AllSponsors from './Component/AllSponsors';
import AllExhibitors from './Component/AllExhibitors';
import AllSpeakersConference from './Component/AllSpeakersConference';
import AllPartnersConference from './Component/AllPartnersConference';
import AllSponsorsConference from './Component/AllSponsorsConference';
import AllWorkshops from './Pages/AllWorkshops';
import Workshop from './Pages/Workshop';

import AllConcerts from './Pages/AllConcerts';
import Concert from './Pages/Concert';
import AllSports from './Pages/AllSports';
import Sport from './Pages/Sport';

import WorkshopSponsor from './Component/OtherComp/WorkshopSponsor';
import WorkshopPartner from './Component/OtherComp/WorkshopPartner';
import ConcertSponsor from './Component/OtherComp/ConcertSponsor';
import ConcertPartner from './Component/OtherComp/ConcertPartner';
import SportSponsor from './Component/OtherComp/SportSponsor'; 
import SportPartner from './Component/OtherComp/SportPartner';
import AllEventFilter from './Pages/AllEventFilter';
import AllEventFilterIndustry from './Pages/AllEventFilterIndustry';
import AllEventFilterFormat from './Pages/AllEventFilterFormat';

import CheckFormStatus from './Pages/CheckFormStatus';

import NotFound from './Pages/404';
import About from './Pages/About';
import Disclamer from './Pages/Disclamer';
import Faqs from './Pages/Faqs';
import Filter from './Pages/Filter';

import CustomForm from './Component/CustomForm';

import News from './Pages/News';
import NewsDetail from './Pages/NewsDetail';

import { GoogleOAuthProvider } from '@react-oauth/google';
import ChatBot from './Component/ChatBot';

function App() {
  const [showScrollButton, setShowScrollButton] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 300) {
      setShowScrollButton(true);
    } else {
      setShowScrollButton(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };


  return (

    <GoogleOAuthProvider clientId="1042334379144-b0egq7it48fmd0spedaliusqsiermqud.apps.googleusercontent.com">
    <div className="App">
      <AddBoxiconsCSS />
      
      <Router>
      <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/event/:slug" element={<Event />} />
          <Route path="/exhibition/:slug" element={<Exhibition />} />
          <Route path="/:slug/speakers" element={<AllSpeakers />} />
          <Route path="/:slug/partners" element={<AllPartners />} />

          <Route path="/:slug/sponsors" element={<AllSponsors />} />

          <Route path="/:slug/exhibitors" element={<AllExhibitors />} />
          <Route path="/:slug/review" element={<AllReviews />} />
          <Route path="/:slug/reviews" element={<AllReviewsConference />} />

          <Route path="/:slug/speaker" element={<AllSpeakersConference />} />
          <Route path="/:slug/partner" element={<AllPartnersConference />} />
          <Route path="/:slug/sponsor" element={<AllSponsorsConference />} />


          <Route path="/:slug/workshop" element={<Workshop />} />
          <Route path="/:slug/concert" element={<Concert />} />
          <Route path="/:slug/sport" element={<Sport />} />
          <Route path="/workshop/:slug/sponsor" element={<WorkshopSponsor />} />
          <Route path="/workshop/:slug/partner" element={<WorkshopPartner />} />
          <Route path="/concert/:slug/sponsor" element={<ConcertSponsor />} />
          <Route path="/concert/:slug/partner" element={<ConcertPartner />} />
          <Route path="/sport/:slug/sponsor" element={<SportSponsor />} />
          <Route path="/sport/:slug/partner" element={<SportPartner />} />
          
          
          
          <Route path="/conference/:slug" element={<Conference />} />

          {/* <Route path="/:country/:city/:slug" element={<ExhibitionNew />} /> */}
          
          <Route path="/login2" element={<VisitorLogin />} />
          <Route path="/exhibitions" element={<AllEvent />} />
          <Route path="/all-conference" element={<AllConference />} />
          
          <Route path="/top-events" element={<TopEvent />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/profile-fill" element={<ProfileMain />} />
          
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/my-events" element={<MyEvent />} />
          <Route path="/my-event-calander" element={<EventCalander />} />
          <Route path="/register" element={<VisitorRegistration />} />
          <Route path="/message" element={<Message />} />
          <Route path="/my-connection" element={<Connection />} />
          <Route path="/follow" element={<Follow />} />
          <Route path="/contact-us" element={<Contact />} />
          <Route path="/connection-pending" element={<ConnectionPending />} />
          <Route path="/login" element={<Login />} />
          <Route path="/otp" element={<OTP />} />
          <Route path="/search" element={<Search />} /> 
          <Route path="/blog" element={<Blog />} />
          <Route path="/form/:formId/:exhibitionId" element={<FillCustomForm />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/terms-conditions" element={<Terms />} />
          <Route path="/workshops" element={<AllWorkshops />} />
          <Route path="/concerts" element={<AllConcerts />} />
          <Route path="/sports" element={<AllSports />} />
          <Route path="/events" element={<AllEventFilter />} />
          {/* <Route path="/:industry" element={<AllEventFilterIndustry />} /> */}
          <Route path="/format/:format" element={<AllEventFilterFormat />} />
          <Route path="/check-status" element={<CheckFormStatus />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/disclamer" element={<Disclamer />} />
          <Route path="/help-support" element={<Faqs />} />
          {/* <Route path="/filter" element={<Filter />} /> */}
          
          {/* <Route path="/filter/*" element={<Filter />} /> */}
  <Route path="/filter/*" element={<Filter />} />

          <Route path="/news" element={<News />} />
          <Route path="/article/:slug" element={<NewsDetail />} />



          <Route path="/forms/:id/:title" element={<CustomForm />} />
          
          

          <Route path="*" element={<NotFound />} />  {/* Catch-all route */}
        </Routes>
        
        {/* Scroll to Top Button */}
        {showScrollButton && (
          <button className="scroll-to-top" onClick={scrollToTop}>
            ↑
          </button>
        )}


<ChatBot/>

        
      </Router>
    </div>
    </GoogleOAuthProvider>
  );
}

export default App;
